module.exports = __webpack_public_path__ + "static/img/img4.8983347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/BSP_Sequencing/img4.png
// module id = U7x9
// module chunks = 16